import React from "react";
import { useAuth } from "../context/AuthContext";
import { useOrg } from "../context/OrgContext";

export default function OrgSwitcher() {
  const { user } = useAuth();
  const { orgs, current, setOrg } = useOrg();

  const canSwitch =
    user?.currentRole === "Super Admin" || user?.currentRole === "Vendor";
  if (!canSwitch || !orgs || orgs.length <= 1) return null;
  const label =
    user?.currentRole === "Super Admin" ? "Organization" : "Workspace";

  return (
    <label className="topbar-switcher">
      <span className="sr-only">{label}</span>
      <select
        className="topbar-select"
        value={current}
        onChange={(e) => setOrg(e.target.value)}
        aria-label={label}
      >
        {orgs.map((org) => (
          <option key={org} value={org}>
            {org}
          </option>
        ))}
      </select>
    </label>
  );
}
